module.exports = __webpack_public_path__ + "img/arrow-down.c6c7687c.svg";